/* eslint react/no-array-index-key: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {FormattedMessage} from 'react-intl';
import True from 'modules/common/Svg/True';
import {bgBlue} from './styles.scss';

const CodeTimeLine = ({currentPosition, challenges}) => (
  <div className="tr pv2 flex items-center flex-row-reverse">
    <p className="b ml2">
      <FormattedMessage id="thetask" defaultMessage="the challenge" />
    </p>
    {challenges.map(
      (_, index) =>
        index < currentPosition ? (
          <True
            key={index}
            className="mh1 br-100"
            bgColor="#60ca91"
            color="#fff"
          />
        ) : (
          <span
            key={index}
            className={cx('ph2 pv1 br-100 mh1', {
              [`${bgBlue} white bn`]: index === currentPosition,
              'bg-white ba b--gray black': index !== currentPosition,
            })}>
            {index + 1}
          </span>
        ),
    )}
  </div>
);

CodeTimeLine.propTypes = {
  currentPosition: PropTypes.number.isRequired,
  challenges: PropTypes.array.isRequired,
};

export default CodeTimeLine;
